import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faVideoSlash } from "@fortawesome/free-solid-svg-icons";

import React, { useState } from "react";
import { Button, Col, Container, Modal, Row } from "react-bootstrap";
import videoCss from "./Video.module.css";
import "video-react/dist/video-react.css";
import { BigPlayButton, Player } from "video-react";
import Zoom from "react-reveal/Zoom";
import Fade from "react-reveal/Fade";
export default function Video() {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);
  return (
    <>
      <Container>
        <Fade top>
          <h1 className="serviceMainTitle text-center">Our Videos</h1>
        </Fade>
        <div className={`${videoCss.bottom}`}></div>
        <Row>
          <Col lg={6} md={6} sm={12}>
            <Zoom left>
              <p className={`${videoCss.description} text-justify`}>
                Hi! I'm Md. Ashikul Hossain. I'm a passionate Web Developer and
                Programmer.<br></br>
                <br></br>I am working online for the last 2 years and have
                created several successful websites running on the internet. I
                try to create a project-based course that helps you to learn
                professionally and make you fell as a complete developer. easy
                learning exists to help you succeed in life.<br></br>
                <br></br>
                Each course has been hand-tailored to teach a specific skill. I
                hope you agree! Whether you’re trying to learn a new skill from
                scratch or want to refresh your memory on something you’ve
                learned in the past, you’ve come to the right place.
              </p>
            </Zoom>
          </Col>
          <Col lg={6} md={6} sm={12} className={`${videoCss.videoContainer}`}>
            <Zoom right>
              <FontAwesomeIcon
                icon={faVideoSlash}
                className={`${videoCss.iconProject}`}
                onClick={handleShow}
              />
            </Zoom>
          </Col>
        </Row>
      </Container>

      <Modal size="lg" show={show} onHide={handleClose}>
        <Modal.Body>
          {" "}
          <Player src="https://media.w3.org/2010/05/sintel/trailer_hd.mp4">
            <BigPlayButton position="center" />
          </Player>
        </Modal.Body>
      </Modal>
    </>
  );
}
